// 审计时间只由服务端维护；不修改 Date、FormData、Blob 等非普通对象。
export function prepareRequestPayload(value) {
  if (Array.isArray(value)) return value.map(prepareRequestPayload)
  if (!value || Object.getPrototypeOf(value) !== Object.prototype) return value
  return Object.keys(value).reduce((result, key) => {
    if (!['createdAt', 'updatedAt', 'createTime', 'updateTime'].includes(key)) {
      result[key] = prepareRequestPayload(value[key])
    }
    return result
  }, {})
}
